import React, {useCallback, useEffect, useMemo, useState} from 'react';

import {settingsApi} from 'api';
import {DataWrapper, PredefinedNotifierType} from 'components';
import {useApiData} from 'hooks';
import {SipMessagesSettings, SipSettings, SipTwilioSettings} from 'types';

import {Messages} from './Messages';
import {TwilioProperties} from './TwilioProperties';
import {TwilioWebhooks} from './TwilioWebhooks';
import {SectionName} from './types';

export const SIPSettings: React.FC = () => {
    const [initialValues, setInitialValues] = useState<SipSettings>();

    const updateInitialValues = useCallback(
        ({section, result}) => setInitialValues((prev) =>
            ({...prev, [section]: result[section]})
        ),
        [setInitialValues]);

    const update = useCallback((section, data) => settingsApi.updateSIP(data).then((result) => ({section, result})), []);

    const {send, loading: fetchLoading, error: fetchError} = useApiData(settingsApi.getSIP,
        {onSuccess: setInitialValues, notificationType: PredefinedNotifierType.FetchError});
    const {send: updateSettings, loading: updateLoading} = useApiData(update,
        {onSuccess: updateInitialValues, notificationType: PredefinedNotifierType.Save});

    const loading = useMemo(() => fetchLoading || updateLoading, [fetchLoading, updateLoading]);

    const handleSubmit = useCallback((section: SectionName, values: SipTwilioSettings | SipMessagesSettings) => {
        updateSettings(section, {[section]: values});
    }, [updateSettings]);

    useEffect(() => {
        send();
    }, [send]);

    return (
        <DataWrapper isLoading={fetchLoading} isError={!!fetchError}>
            <TwilioWebhooks
                initialValues={initialValues?.twilio}
                loading={loading}
            />
            <TwilioProperties
                initialValues={initialValues?.twilio}
                loading={loading}
                onSubmit={(values) => handleSubmit(SectionName.Twilio, values)}
            />
            <Messages
                initialValues={initialValues?.messages}
                loading={loading}
                onSubmit={(values) => handleSubmit(SectionName.Messages, values)}
            />
        </DataWrapper>
    );
};